  <ifc-status-label [status]="alligatorDataSyncLabels" [value]="alligatorDataSync"></ifc-status-label>